var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherCopyLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.126,
    height: 22.126,
    viewBox: "0 0 22.126 22.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M15.513,13.5H24.57a2.013,2.013,0,0,1,2.013,2.013V24.57a2.013,2.013,0,0,1-2.013,2.013H15.513A2.013,2.013,0,0,1,13.5,24.57V15.513A2.013,2.013,0,0,1,15.513,13.5Z",
    transform: "translate(-3.456 -3.456)",
    fill: "none",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M6.019,16.082H5.013A2.013,2.013,0,0,1,3,14.07V5.013A2.013,2.013,0,0,1,5.013,3H14.07a2.013,2.013,0,0,1,2.013,2.013V6.019",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCopyLight);
export default __webpack_public_path__ + "static/media/feather-copy-light.71718bf8c9e97293b79ef4f128cd84a3.svg";
export { ForwardRef as ReactComponent };